// Module
var code = "<div class=\"\" view=\"Repeat\" data-items=\"[[ elements ]]\" data-as=\"element\"> <div view=\"[[ element.modelName ]]\" data=\"[[ element ]]\"></div> </div> ";
// Exports
export default code;